var map;
var InfoObj = [];

var icons = {
  adoc: {
    icon: "https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909",
  },
};

var markersOnMap = [
  {
    storecode: "A01",
    placeName: "ADOC San Luis",
    storeAddress: "CC San Luis, Local 16 B, Calle a San Antonio Abad.",
    schedule: "Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm",
    phone: "22255820",
    whatsapp: "72752074",
    page: "https://g.page/r/CfP84zleqJULEBA",
    review: "https://g.page/r/CfP84zleqJULEB4/review",
    zona: 1,
    LatLng: [
      {
        lat: 13.7157911,
        lng: -89.2128899,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A02",
    placeName: "ADOC Plaza Mundo Apopa",
    storeAddress: "Local 26, Km 12 Carretera Troncal del Norte, Apopa.",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "25646439",
    whatsapp: "72752074",
    page: "https://g.page/r/Cd_LtHu4qpQJEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.7906306,
        lng: -89.1762908,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A03",
    placeName: "ADOC CC El Encuentro San Miguel",
    storeAddress:
      "CC El Encuentro El Sitio, Local 41 y 43 Carretera Panamericana, San Miguel",
    schedule: "Lunes a Domingo: 10:00am a 8:00pm",
    phone: "22278356",
    whatsapp: "72752074",
    page: "https://g.page/r/Cae-Aj5AuYn6EBA",
    review: "",
    zona: 4,
    LatLng: [
      {
        lat: 13.4961222,
        lng: -88.1976578999999,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A04",
    placeName: "ADOC Plaza Merliot",
    storeAddress: "Plaza Merliot, Local 312 y 313, Santa Tecla",
    schedule: "Lunes a Domingo: 9:00am a 7:00pm",
    phone: "23341103",
    whatsapp: "72752074",
    page: "https://goo.gl/maps/qGWiqSuSxByxPFPw8",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6789276,
        lng: -89.2759958,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A06",
    placeName: "ADOC Zacatecoluca",
    storeAddress: "2a. Calle Pte. y Av. Juan Manuel Rodríguez",
    schedule: "Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 1:00pm",
    phone: "23341103",
    whatsapp: "72752074",
    page: "https://g.page/r/Ce04dQZVXOoHEBA",
    review: "",
    zona: 2,
    LatLng: [
      {
        lat: 13.508621421937109,
        lng: -88.87020653373843,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A09",
    placeName: "ADOC Metrocentro Santa Ana",
    storeAddress:
      "CC Metrocentro Santa Ana Local 142, 143, 144 y 145, Etapa 20, Santa Ana",
    schedule: "Lunes a Domingo: 9:00am a 7:00pm",
    phone: "24408775",
    whatsapp: "72752074",
    page: "https://g.page/r/CeAzFznqNcSDEBA",
    review: "",
    zona: 3,
    LatLng: [
      {
        lat: 13.9769105,
        lng: -89.5617897,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A13",
    placeName: "ADOC Rubén Darío",
    storeAddress:
      "CC Dalumo, Calle Rubén Darío y 5a Av. Sur No. 324 y 326, San Salvador",
    schedule: "Lunes a Domingo: 8:00am a 6:00pm",
    phone: "22211826",
    whatsapp: "72752074",
    page: "https://g.page/r/CfiiZaY4jPlhEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6985622,
        lng: -89.1941383,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A26",
    placeName: "ADOC Metrocentro San Salvador",
    storeAddress:
      "CC Metrocentro San Salvador Local 44, 45 y 46, 4a Etapa, San Salvador",
    schedule: "Domingo a Jueves: 9:00am a 7:00pm<br> Viernes y Sábado: 9:00am a 8:00pm",
    phone: "22603943",
    whatsapp: "72752074",
    page: "https://g.page/r/CZUDBYZGQnuWEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.7060227,
        lng: -89.2113121,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A29",
    placeName: "ADOC Av. España",
    storeAddress:
      "Av. España y C. Delgado # 114, Edif. España, Local 1 y 2, San Salvador",
    schedule: "Lunes a Domingo: 8:00am a 6:00pm",
    phone: "22224960",
    whatsapp: "72752074",
    page: "https://g.page/r/CYu1WCIKEOVTEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6993013,
        lng: -89.1914196,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A34",
    placeName: "ADOC Metrocentro Sonsonate",
    storeAddress: "CC Metrocentro Sonsonate, Local 42, 43 y 44, Sonsonate",
    schedule: "Lunes a Domingo: 9:00am a 7:00pm",
    phone: "24504235",
    whatsapp: "72752074",
    page: "https://g.page/r/CVOS3l6P1NTuEBA",
    review: "",
    zona: 3,
    LatLng: [
      {
        lat: 13.7122382,
        lng: -89.7252957,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A39",
    placeName: "ADOC Multiplaza",
    storeAddress: "CC Multiplaza Local B-83, Antiguo Cuscatlán",
    schedule: "Lunes a Domingo: 10:00am a 7:00pm",
    phone: "22434831",
    whatsapp: "72752074",
    page: "https://g.page/r/CZpCbCTfK3NNEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6794759,
        lng: -89.2483583,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A40",
    placeName: "ADOC Cascadas",
    storeAddress: "CC Cascadas, Local 147, Antiguo Cuscatlán",
    schedule: "Lunes a Domingo: 9:00am a 7:00pm",
    phone: "22438397",
    whatsapp: "72752074",
    page: "https://goo.gl/maps/vosYV5cSuVDQTAUq5",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.677884,
        lng: -89.2503862,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A41",
    placeName: "ADOC Metrocentro",
    storeAddress: "CC Metrocentro, Local 77 y 78, 3a etapa, San Salvador",
    schedule: "Domingo a Jueves: 9:00am a 7:00pm<br> Viernes y Sábado: 9:00am a 8:00pm",
    phone: "22608406",
    whatsapp: "72752074",
    page: "https://g.page/r/CfCaVJ6Wpf0JEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.7063894,
        lng: -89.2124064,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A47",
    placeName: "ADOC Metrosur",
    storeAddress: "CC Metrosur Local C-313 Etapa 6, San Salvador",
    schedule: "Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm",
    phone: "22611238",
    whatsapp: "72752074",
    page: "https://g.page/r/CQSPoL05pqkWEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.7044657,
        lng: -89.214379,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A50",
    placeName: "ADOC Plaza Mundo Soyapango",
    storeAddress: "CC Plaza Mundo, Local 54, 55 y 56, Nivel 1, San Salvador",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "22773546",
    whatsapp: "72752074",
    page: "",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6984952,
        lng: -89.1498436,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A56",
    placeName: "ADOC Usulután",
    storeAddress: "4a Av. Sur y Calle Grimaldi, Usulután",
    schedule: "Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 1:00pm",
    phone: "26620080",
    whatsapp: "72752074",
    page: "https://goo.gl/maps/bciF91EoSYBMrG2m7",
    review: "",
    zona: 4,
    LatLng: [
      {
        lat: 13.3453409,
        lng: -88.4380508,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A59",
    placeName: "ADOC Ahuachapan",
    storeAddress: "Av. Francisco Menéndez y 4a calle Pte. No 3-1, Ahuachapán",
    schedule: "Lunes a Domingo: 8:00am a 5:00pm",
    phone: "24430791",
    whatsapp: "72752074",
    page: "https://g.page/r/CbrBiszvPIkSEBA",
    review: "",
    zona: 3,
    LatLng: [
      {
        lat: 13.9227292,
        lng: -89.8463441,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A70",
    placeName: "ADOC Plaza Mundo Soyapango",
    storeAddress: "c",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "22777265",
    whatsapp: "72752074",
    page: "https://g.page/r/CVCleKh0ui52EBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6980815,
        lng: -89.1509929,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A73",
    placeName: "ADOC Metrocentro San Miguel",
    storeAddress:
      "CC Metrocentro San Miguel Local 143 y 144, Eta 19, San Miguel",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "26670451",
    whatsapp: "72752074",
    page: "https://g.page/r/CeAzFznqNcSDEBA",
    review: "",
    zona: 4,
    LatLng: [
      {
        lat: 13.4610745,
        lng: -88.1647383,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A77",
    placeName: "ADOC Metrocentro Lourdes",
    storeAddress: "CC Metrocentro Lourdes Locales 7I y 8I, 2a Etapa",
    schedule: "Lunes a Domingo: 9:00am a 7:00pm",
    phone: "23465810",
    whatsapp: "72752074",
    page: "https://goo.gl/maps/S48GvD71TkfMwcqJA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.7275632,
        lng: -89.3591067,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A84",
    placeName: "ADOC Chalatenango",
    storeAddress:
      "3a. avenida norte y 4a. calle poniente No. 7 local B, Chalatenango",
    schedule: "Lunes a Domingo: 8:00am a 5:00pm",
    phone: "23011741",
    whatsapp: "72752074",
    page: "https://g.page/r/CVroprpkZXo1EBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 14.0405591,
        lng: -88.9393413,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A90",
    placeName: "ADOC La Gran Vía",
    storeAddress: "CC La Gran Vía, local 410, Antiguo Cuscatlán",
    schedule: "Lunes a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 7:00pm",
    phone: "22789662",
    whatsapp: "72752074",
    page: "https://g.page/r/CebjzKaz-wIBEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6782308,
        lng: -89.2539765,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A91",
    placeName: "ADOC Galerias",
    storeAddress: "CC Galerias, 1er Nivel, Local 142, San Salvador",
    schedule: "Lunes a Domingo: 10:00am a 7:00pm",
    phone: "22230347",
    whatsapp: "72752074",
    page: "https://g.page/r/CWLF5t84E2chEBA",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.702284,
        lng: -89.2300696,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A92",
    placeName: "ADOC Plaza Mundo Soyapango",
    storeAddress: "CC Plaza Mundo, Local 194 y 195, 4a Etapa, San Salvador",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "22776395",
    whatsapp: "72752074",
    page: "",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.6987916,
        lng: -89.1517467,
      },
    ],
    type: "adoc",
  },
  {
    storecode: "A93",
    placeName: "ADOC CC Plaza Mundo Usulutan",
    storeAddress:
      "CC Plaza Mundo Local 62, Km 119 Carr. Del Litoral CA-2, Ruta Nacional 14, Usulutan",
    schedule: "Lunes a Domingo: 9:00am a 8:00pm",
    phone: "22776395",
    whatsapp: "72752074",
    page: "",
    review: "",
    zona: 1,
    LatLng: [
      {
        lat: 13.34325,
        lng: -88.465694,
      },
    ],
    type: "adoc",
  },
];

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo() {
  for (var i = 0; i < markersOnMap.length; i++) {
    var contentString =
      '<div class="place-name">' + markersOnMap[i].placeName + "</div>";
    contentString +=
      '<div class="place-general">' + markersOnMap[i].storeAddress + "</div>";
    contentString +=
      '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
    if (markersOnMap[i].phone !== "")
      contentString +=
        '<div class="place-link"><a class="place-link" href="tel:+503' +
        markersOnMap[i].phone +
        '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
        markersOnMap[i].phone +
        "</a></div>";
    contentString +=
      '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
      markersOnMap[i].whatsapp +
      '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
      markersOnMap[i].whatsapp +
      "</a></div>";
    contentString +=
      '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
      markersOnMap[i].LatLng[0].lat +
      "%2C" +
      markersOnMap[i].LatLng[0].lng +
      '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
    if (markersOnMap[i].page !== "")
      contentString +=
        '<div class="place-link"><a class="place-link" target="_blank" href="' +
        markersOnMap[i].page +
        '">Ver mapa</a></div>';
    if (markersOnMap[i].review !== "")
      contentString +=
        '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
        markersOnMap[i].review +
        '">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map,
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    marker.addListener("click", function () {
      closeOtherInfo();
      infowindow.open(marker.get("map"), marker);
      InfoObj[0] = infowindow;
    });

    switch (markersOnMap[i].zona) {
      case 1:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info").innerHTML += contentDiv;
        break;

      case 2:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info2").innerHTML += contentDiv;
        break;

      case 3:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info3").innerHTML += contentDiv;
        break;

      case 4:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info4").innerHTML += contentDiv;
        break;

      default:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info").innerHTML += contentDiv;
        break;
    }
  }
}

function closeOtherInfo() {
  if (InfoObj.length > 0) {
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon) {
  var centerStore = { lat: posLat, lng: posLon };
  map.setCenter(centerStore);
}

function positionOk(pos) {
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = { lat: latitudeMap, lng: longitudMap };
  map.setCenter(centerStore);
}

function positionKO() {
  const centerStore = { lat: 13.7063894, lng: -89.2124064 };
  map.setCenter(centerStore);
}

function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 15,
    center: { lat: 13.7063894, lng: -89.2124064 },
    mapId: "46642173f0d6b463",
  });

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);
  }

  addMarkerInfo();
}

function openPage(pageName, elmnt) {
  var i, tabcontent;

  tabcontent = document.getElementsByClassName("tabcontent2");

  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}
